import React from "react";
import { Col, Row, Card } from "antd";
import insight from "../images/insight-engine.svg";
import { TryProduct } from "./TryTheProduct";

interface userProp { currentUser: any; }

const InsightEngine: React.FC<userProp> = ({ currentUser }) =>  {
  return (
    <Card hoverable bodyStyle={{width: '100%'}} className={currentUser ? "product-layout product-layout-logged" : "product-layout"}>
      <div >
        <Row>
          <Col>
        <div className="product-description-img insight-engine">
          <div className="product-img-border">
            <img  
              className="product-img"
              src={insight}
              height="100%"
              alt="insight-engine-logo"
            />
          </div>
        </div>
        </Col>
        </Row>
        <p className="eyebrow-text">Tell the story</p>
        <h2 className="h2 h2-insight-engine">Insight Engine</h2>
        <p className="p" style={{width: '100%'}}>
         As Science Central evolves, you can analyze and visualize your data to explore, interpret, and communicate research insights.
        </p>
        <p className="product-button">Analyze Data
          <TryProduct />
        </p>
        </div>
      </Card>

  );
};

export default InsightEngine;
